import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './style.module.scss';

interface QuizCountdownProps {
  timeUntilNextQuiz: number;
}

const QuizCountdown: React.FC<QuizCountdownProps> = ({ timeUntilNextQuiz }) => {
  const { t } = useTranslation();
  const [displayTime, setDisplayTime] = useState(timeUntilNextQuiz);
  const totalSeconds = Math.ceil(displayTime / 1000);
  const seconds = totalSeconds % 60;
  const isUrgent = totalSeconds <= 5;

  useEffect(() => {
    setDisplayTime(timeUntilNextQuiz);
  }, [timeUntilNextQuiz]);

  return (
    <div className={styles.countdownCard}>
      <div className={`${styles.countdownContent} tablet-landscape:!flex-row tablet-landscape:!justify-center`}>
        <div className={styles.countdownLabel}>{t('games.snake.next_quiz')}</div>
        <div className={`${styles.countdownTimer} tablet-landscape:!text-xl ${
          isUrgent ? styles.countdownTimerUrgent : ''
        }`}>
          00:{seconds.toString().padStart(2, '0')}
        </div>
      </div>
    </div>
  );
};

export default QuizCountdown;

